export interface MotivoServicoModel {
  codigo: number;
  valorIntegracao: string;
  descricao: string;
}

export const PANE_SECA: MotivoServicoModel = {
  codigo: 1,
  valorIntegracao: "PANE_SECA",
  descricao: "Pane Seca",
};
export const PANE_ELETRICA: MotivoServicoModel = {
  codigo: 2,
  valorIntegracao: "PANE_ELETRICA",
  descricao: "Pane Elétrica",
};
export const PANE_MECANICA: MotivoServicoModel = {
  codigo: 3,
  valorIntegracao: "PANE_MECANICA",
  descricao: "Pane Mecânica",
};
export const FUNDIU_MOTOR: MotivoServicoModel = {
  codigo: 4,
  valorIntegracao: "FUNDIU_MOTOR",
  descricao: "Fundiu o motor",
};
export const COLISAO: MotivoServicoModel = {
  codigo: 5,
  valorIntegracao: "COLISAO",
  descricao: "Colisão",
};
export const CAPOTADO: MotivoServicoModel = {
  codigo: 6,
  valorIntegracao: "CAPOTADO",
  descricao: "Capotado",
};

export const MOTIVOS_SERVICO_GUINCHO: MotivoServicoModel[] = [
  PANE_SECA,
  PANE_ELETRICA,
  PANE_MECANICA,
  FUNDIU_MOTOR,
  COLISAO
];
